import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a href="https://www.dev-story.com/" target="_blank"  rel="noreferrer">
            DEV STORY
          </a>{" "}
          2022
        </p>
      </div>
    </div>
  );
};

export default Footer;
